export const environment = {
    firebase: {
        apiKey: "AIzaSyDhOAIuXdFyJ0aRSIFEEcqsIzip_I7QQLg",
        authDomain: "mytruthstar.firebaseapp.com",
        projectId: "mytruthstar",
        storageBucket: "mytruthstar.firebasestorage.app",
        messagingSenderId: "277803704102",
        appId: "1:277803704102:web:d96673e76f18ba2c2c6be7",
        measurementId: "G-N86Q17D77Z"
    },
    baseUrl: 'https://my.truthstar.com/api'
};
